import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {firestoreConnect, withFirestore, isLoaded} from "react-redux-firebase";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {connect} from "react-redux";
import {ACCEPTED, DECLINED, WAITING_FOR_DECISION} from "../../utils/employeeStatus";
import withCompanyManagerHOC from "../../components/auth/CompanyManagerHOC";
import {SERVICE_TYPES} from "../../constants/ServiceTypes";
import Select from 'react-select';
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import {COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import Dropzone from 'react-dropzone'
import {PROFILE_PIC_PATH} from "../../constants/STORAGE_PATHS";
import {setCompanyProfilePicture} from "../../utils/AuthFunctions";
import DropzoneProfilePicture from "../../components/DropzoneProfilePicture";
import {CustomInput} from "../../components/Inputs";
import CompanyRegisterForm from "../../components/auth/CompanyRegisterForm";
import {setCompanyData} from "../../redux/register/action";
import {StyledButton} from "../../components/Buttons";
import {PROFILE_URL} from "../../constants/URLS";


class CompanySettings extends Component {
    constructor() {
        super();
        this.state = {
            loaded: false,
            services: [],
            serviceValues: [],
        }
    }

    componentDidMount() {
        if (this.props.company && isLoaded(this.props.company) && !this.state.loaded) {
            console.log('set mount')
            this.props.setCompanyData({
                companyAddress: this.props.company.companyAddress,
                companyName: this.props.company.companyName,
                formFilled: true
            })
            this.setState({
                loaded: true,
                services: this.props.company.services,
                serviceValues: this.DefaultServiceTypeOptions()
            })
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.company && isLoaded(this.props.company) && !this.state.loaded) {
            console.log('set update')
            this.props.setCompanyData({
                companyAddress: this.props.company.companyAddress,
                companyName: this.props.company.companyName,
                formFilled: true
            })
            this.setState({
                loaded: true,
                services: this.props.company.services,
                serviceValues: this.DefaultServiceTypeOptions()
            })
        }
    }

    ServiceTypeToOptions = (service_types) => {
        let arr = []
        Object.entries(service_types).forEach(e => {
            arr.push({value: e[0], label: e[1].name})
        })
        return arr
    }
    DefaultServiceTypeOptions = () => {
        if (this.props.company &&
            this.props.company.services &&
            this.props.company.services.length !== 0) {
            let arr = []
            this.props.company.services.forEach(e => {
                arr.push(this.ServiceTypeToOptions(SERVICE_TYPES)[e])
            })
            return arr
        } else return []
    }

    render() {
        console.log(this.props)
        //console.log(this.state)
        if(this.state.loaded){
            return (
                <div style={{maxHeight: '100vh', boxSizing: 'border-box', overflow: 'auto'}}>


                <BackgroundDiv/>

                    <h2>Company Settings</h2>

                    <Select
                        isMulti
                        options={this.ServiceTypeToOptions(SERVICE_TYPES)}
                        onChange={(e) => {
                            console.log(e)
                            let arr = []
                            if (e) {
                                e.forEach(e => {
                                    arr.push(Number(e.value))
                                })
                                this.setState({
                                    services: arr,
                                    serviceValues: e,
                                })
                            } else {
                                this.setState({
                                    services: [],
                                    serviceValues: [],
                                })
                            }

                        }}
                        value={
                            //this.DefaultServiceTypeOptions()
                            this.state.serviceValues
                        }
                    />


                    <StyledButton onClick={() => {
                        this.props.firestore.collection(COMPANY_DB_PATH)
                            .doc(this.props.auth.uid).update({
                            services: this.state.services,
                            //companyName: this.state.companyName,
                            companyName: this.props.companyRegister.companyName,
                            companyAddress: this.props.companyRegister.companyAddress,
                        }).then(() => {
                            this.props.history.push(PROFILE_URL)
                        })
                    }} disabled={!this.props.companyRegister.formFilled}>Update
                    </StyledButton>


                    <Dropzone accept={'image/*'} onDrop={async (files) => {
                        await setCompanyProfilePicture(
                            this.props.firebase,
                            files[0],
                            this.props.auth.uid
                        )
                    }} multiple={false}>
                        {({getRootProps, getInputProps}) => (
                            <section>
                                <div className={'no-focus'} {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <DropzoneProfilePicture company={this.props.company}/>
                                </div>
                            </section>
                        )}
                    </Dropzone>

                    {/*<CustomInput textTransform={'none'}
                                 value={this.state.companyName}
                                 onChange={e => {
                                     this.setState({companyName: e.target.value})
                                 }}
                    />*/}

                    <CompanyRegisterForm/>


                    <div>

                    </div>
                </div>
            );
        } else {
            return (
                <div>loadign profile</div>
            )
        }


    }
}
const mapStateToProps = state => {
    return {
        companyRegister: state.companyRegister
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setCompanyData: (data) => dispatch(setCompanyData(data, true)),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withFirestore,
    UserIsAuthenticated,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),
    connect((state, props) => ({
        company: state.firestore.data.companySettings,
    })),
    firestoreConnect(props => {
            return [
                {
                    collection: COMPANY_DB_PATH,
                    doc: props.auth.uid,
                    storeAs: 'companySettings'
                },
            ]
        }
    ),
    withCompanyManagerHOC,
)(CompanySettings);